import React, { useEffect, useRef, useState } from "react";
import { AvatarEditorBlock } from "./AvatarEditorBlock";
import "./AvatarBlock.css";
import { Collapser } from "../../../../components/collapser/Collapser";

export const AvatarBlock = ({onImageUpdate, initialAvatarUrl}:{onImageUpdate: (image: HTMLCanvasElement)=>void, initialAvatarUrl: string})=>{
    const [windowDragFile, setWindowDragFile] = useState<DataTransferItem>(null);
    const [originalImage, setOriginalImage] = useState<HTMLImageElement>(null);
    const [formDrag, setFormDrag] = useState(false);
    const [showEditor, setShowEditor] = useState(false);

    const canvasRef = useRef<HTMLCanvasElement>(null);

    useEffect(()=>{
        if (originalImage){
            onImageUpdate(canvasRef.current);
        } else {
            onImageUpdate(null);
        }
    }, [canvasRef.current, originalImage])

    const processFile = (selectedFile: File)=>{
        if (!selectedFile){
            return;
        }
        setOriginalImage(null)
        const reader = new FileReader();
        reader.onload = ()=>{
            console.log('loaded');
            const img = new Image();
            img.onload= ()=>{
                setOriginalImage(img);
            };
            img.src = reader.result as string;   
        }
        reader.onloadstart = ()=>{
            console.log('loading');
        }
        reader.onerror = ()=>{
            console.log('error');
        }
        reader.onabort = ()=>{
            console.log('abort');
        }
        reader.readAsDataURL(selectedFile);
    }

    const findDragDropFile = (items: DataTransferItemList)=>{
        if (items) {
            const foundFile = [...items].find((item, i) => {
                if (item.kind === "file") {
                    return true;
                }
            });
            return foundFile;
        }
        return null
    }

    const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>)=>{
        const selectedFile = e.target.files[0];
        console.log(selectedFile);
        processFile(selectedFile);
    }

    useEffect(()=>{
        const handleDragOver = (e: DragEvent)=>{
            e.preventDefault();
            const foundFile = findDragDropFile(e.dataTransfer.items)
            if (foundFile){
                setWindowDragFile(foundFile);
            } else {
                setWindowDragFile(null);
            }
        };
        const handleDragLeave=(e: DragEvent)=>{
            console.log(e.relatedTarget);
            if (!(e.relatedTarget as HTMLElement)?.closest('html')){
                setWindowDragFile(null)
            }
        }
        const handleDragEnd=(e: DragEvent)=>setWindowDragFile(null)
        window.addEventListener('dragover', handleDragOver);
        window.addEventListener('dragleave', handleDragLeave);
        window.addEventListener('dragend', handleDragEnd);
        window.addEventListener('drop', handleDragEnd);
        return ()=>{
            window.removeEventListener('dragover', handleDragOver);
            window.removeEventListener('dragleave', handleDragLeave);
            window.removeEventListener('dragend', handleDragEnd);
            window.removeEventListener('drop', handleDragEnd);
        }
    },[])

    const handleFormDragOver = (e: React.DragEvent)=>{
        e.preventDefault();
        if (windowDragFile){
            setFormDrag(true);
        }
    }

    const handleFormDragLeave = (e: React.DragEvent)=>{
        e.preventDefault();
        setFormDrag(false);
    }

    const handleFormDrop = (e:React.DragEvent)=>{
        e.preventDefault(); 
        setFormDrag(false);
        setWindowDragFile(null);
        const foundFile = findDragDropFile(e.dataTransfer.items)
        if (foundFile){
            const file = foundFile.getAsFile();
            processFile(file);
        } else {
            
        }
    }
    
    return (
        <div className="AvatarBlock_wrapper">
            <div className="AvatarBlock"
                onDragOver={handleFormDragOver}
                onDragLeave={handleFormDragLeave}
                onDrop={handleFormDrop}
            >
            <input type="file" id={'af_label_id'} className="avatarEditor_fileInput" onChange={handleFileChange}></input>
                <div className="AvatarBlock_avatar">
                    <canvas className={originalImage ? "AvatarBlock_previewCanvas" : "AvatarBlock_previewCanvas AvatarBlock_previewCanvas--hide" } ref={canvasRef}></canvas>
                    {initialAvatarUrl && !originalImage && <img className="AvatarBlock_previewCanvas" src={initialAvatarUrl}></img>}
                    <label htmlFor="af_label_id" className="avatarEditor_fileLabel">
                        {originalImage ? '' : 'select file or drag-drop'}
                    </label>
                </div>
            

            {originalImage && <div className="AvatarBlock_editButton" onClick={()=>setShowEditor(last=>!last)}>
                edit
            </div>}
            {originalImage && <div className="AvatarBlock_editButton AvatarBlock_editButton--remove" onClick={()=>setOriginalImage(null)}>
                remove
            </div>}
            
            {!originalImage && !windowDragFile && !formDrag && <div className="avatarEditor_overlay avatarEditor_overlay_empty"></div>}
            {windowDragFile && !formDrag && <div className="avatarEditor_overlay avatarEditor_overlay_drag">drag here</div>}
            {formDrag && <div className="avatarEditor_overlay avatarEditor_overlay_drop">drop file</div>}
        </div>
        <Collapser collapsed={showEditor && !!originalImage}>
            <AvatarEditorBlock originalImage={originalImage} previewCanvas={canvasRef.current}></AvatarEditorBlock>
        </Collapser>
        
    </div>
    )
}